export default __webpack_public_path__ + "static/media/snowflake.68b39b13.svg";